/**
 * @generated SignedSource<<95ef4ebc696f03ae9af9b7a6bf7b8672>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactActivityHistoryCreateInput = {
  type: string;
  description?: string | null;
  meta?: any | null;
  createdBy?: string | null;
  contactId: string;
};
export type contactActivityHistoryCreateMutation$variables = {
  input: ContactActivityHistoryCreateInput;
};
export type contactActivityHistoryCreateMutation$data = {
  readonly createContactActivityHistory: {
    readonly contactActivityHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"contactActivityHistoryInlineFragment">;
    };
  };
};
export type contactActivityHistoryCreateMutation = {
  variables: contactActivityHistoryCreateMutation$variables;
  response: contactActivityHistoryCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "meta",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactActivityHistoryCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactActivityHistoryPayload",
        "kind": "LinkedField",
        "name": "createContactActivityHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactActivityHistory",
            "kind": "LinkedField",
            "name": "contactActivityHistory",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "contactActivityHistoryInlineFragment",
                "selections": (v2/*: any*/)
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactActivityHistoryCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactActivityHistoryPayload",
        "kind": "LinkedField",
        "name": "createContactActivityHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactActivityHistory",
            "kind": "LinkedField",
            "name": "contactActivityHistory",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68edce31a3fb64cdba7cc55aea985d86",
    "id": null,
    "metadata": {},
    "name": "contactActivityHistoryCreateMutation",
    "operationKind": "mutation",
    "text": "mutation contactActivityHistoryCreateMutation(\n  $input: ContactActivityHistoryCreateInput!\n) {\n  createContactActivityHistory(input: $input) {\n    contactActivityHistory {\n      ...contactActivityHistoryInlineFragment\n      id\n    }\n  }\n}\n\nfragment contactActivityHistoryInlineFragment on ContactActivityHistory {\n  id\n  type\n  description\n  createdAt\n  meta\n}\n"
  }
};
})();

(node as any).hash = "368465d4d683d8a00a682f4c7afd9e10";

export default node;
